export const VIEW_ALL_TASKS = 'correspondent/View_All_Tasks';
export const VIEW_ALL_TASKS_SUCCESS = 'correspondent/View_All_Tasks_Success';
export const VIEW_ALL_TASKS_FAILURE = 'correspondent/View_All_Tasks_Failure';

export const viewAllTasks = (data) => {
    return {
        type: VIEW_ALL_TASKS,
        data
    };
}
export const viewAllTasksSuccess = (data) => {
    return {
        type: VIEW_ALL_TASKS_SUCCESS,
        data
    };
}
export const viewAllTasksFailure = (error) => {
    return {
        type: VIEW_ALL_TASKS_FAILURE,
        error
    };
}